export const EVENT_TARGET = {
    STAFF: "STAFF",
    PATIENT: "PATIENT",
    CARE_NOTE: "CARE_NOTE",
    CARE_PLAN: "CARE_PLAN",
    TIMETABLE: "TIMETABLE",
    ATTACHMENT: "ATTACHMENT",
    LEAVE: "LEAVE",
    STAFF_ANNUAL_LEAVE: "STAFF_ANNUAL_LEAVE",
    ROTA: "ROTA",
    PARENT_SITE: "PARENT_SITE",
    SITE: "SITE",
    Emergency: "Emergency",
    GP: "GP",
    kin: "KIN",
    Interest: "Interest",
    Referral: "Referral",
    Rejection: "Rejection",
    History: "History",
    Admit: "Admit",
    ACTIVITY: "ACTIVITY",
    APPOINTMENT: "APPOINTMENT",
    Top_Notify: "top-notification",
    Clear_Top_Notify: "clear-top-notification",
};

export const ACTION_TYPE = { CREATE: "CREATE", UPDATE: "UPDATE", DELETE: "DELETE" };
